// Scope one gate to a mounted page; superseded reads must not change its state.
export function createLatestRequest() {
  let sequence = 0;
  return { start() { const current = ++sequence; return () => current === sequence; }, invalidate() { sequence++; } };
}
